import { styled, useMediaQuery } from '@mui/material';

export const DistribuidorCenterContainer = styled('div')(({ theme }) => ({
	maxWidth: `${theme.breakpoints.values.lg}px`,
	width: useMediaQuery(theme.breakpoints.down('lg')) ? 'calc(100vw - 40px)' : '',
	padding: '0',
}));
